import { WeeklyPlan, WeeklyPlanCreate, WeeklyPlanUpdate } from '../types/weekly-plan';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/weekly-plans';

export const getWeeklyPlans = async (): Promise<WeeklyPlan[]> => {
  return await fetcher(`${API_URL}/read`);
};

export const getWeeklyPlansByUser = async (userId: string): Promise<WeeklyPlan[]> => {
  return await fetcher(`${API_URL}/read?user_id=${userId}`);
};

export const getWeeklyPlanById = async (id: string): Promise<WeeklyPlan> => {
  return await fetcher(`${API_URL}/read/${id}`);
};

export const createWeeklyPlan = async (data: WeeklyPlanCreate): Promise<WeeklyPlan> => {
  return await fetcher(`${API_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const updateWeeklyPlan = async (id: string, data: WeeklyPlanUpdate): Promise<WeeklyPlan> => {
  return await fetcher(`${API_URL}/update/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const deleteWeeklyPlan = async (id: string): Promise<boolean> => {
  return await fetcher(`${API_URL}/delete/${id}`, {
    method: 'DELETE',
  });
};
